export const getDefaultValues = (mediaGroupDetails) => ({
  MediaGroupTitle: mediaGroupDetails?.MediaGroupTitle || '',
  MediaGroupSubTitle: mediaGroupDetails?.MediaGroupSubTitle || '',
  MediaGroupImage: mediaGroupDetails?.MediaGroupImage || '',
  MediaGroupBackDrop: mediaGroupDetails?.MediaGroupBackDrop || '',
  MediaGroupBody: mediaGroupDetails?.MediaGroupBody || '',
  MediaGroupMediaGroupTypeID: mediaGroupDetails?.MediaGroupMediaGroupTypeID || '',
});
